// Dotisk štítku jedné role — ze seznamu i z detailu. Na cíl tisku se ptáme
// pokaždé; poslední volba se drží jako předvybraná (společně s příjmem).

import type { PrintTarget } from './PrintTargetModal';
import type { Piece } from './types';

/** Naposledy zvolený cíl tisku — používá se jako předvybraná možnost. */
export function tiskneNaZebru(): boolean {
  return localStorage.getItem('sklad-tisk-zebra') === '1';
}

export function zapamatujCilTisku(naZebru: boolean): void {
  localStorage.setItem('sklad-tisk-zebra', naZebru ? '1' : '0');
}

/**
 * Vytiskne štítek role. Na štítku je evidovaná metráž z příjmu, ne aktuální
 * stav — linky pod ní slouží k ručnímu odečítání odběrů, takže dotisk musí
 * vypadat stejně jako originál.
 */
export async function tiskStitkuRole(piece: Piece, target: PrintTarget): Promise<void> {
  const { generateLabelsPdf } = await import('./labelsPdf');
  await generateLabelsPdf(
    [
      {
        serial_number: piece.serial_number,
        latka_name: piece.latka_name,
        latka_image: piece.latka_image,
        quantity: piece.quantity,
        unit: piece.unit,
        folded: piece.folded,
      },
    ],
    piece.latka_name,
    target,
  );
}
